import PropTypes from 'prop-types';

import { TrlFieldAlertIcon } from '»components/atoms/TrlFieldAlertIcon';
import { TrlTooltip } from '»components/atoms/TrlTooltip';

import { LockedInputSpan, LockedInputStyled } from './TrlLockedField.styles';

export const TrlLockedField = ({ value, showAlertIcon }) => {
  const fieldValue = value !== null && value !== undefined ? String(value) : '';

  return (
    <TrlTooltip text={fieldValue}>
      <LockedInputSpan>
        <LockedInputStyled
          type="text"
          disabled
          value={fieldValue}
          endAdornment={
            <TrlFieldAlertIcon showIcon={showAlertIcon} alertType="warning" />
          }
        />
      </LockedInputSpan>
    </TrlTooltip>
  );
};

TrlLockedField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  showAlertIcon: PropTypes.bool,
};
